
import { Text, Button, ModalProps, Space } from '@mantine/core';
import { UALContext } from 'ual-reactjs-renderer';


import { useModals } from '@mantine/modals';
import { useContext, useEffect, useLayoutEffect, useState } from 'react';

import UnclaimedBalanceNotification from './components/NFT/UnclaimedBalanceNotification';
import { AAMiddleware } from './store/AAMiddleware';

interface IBackedAmount {
    amount: any;
    token_symbol: any;
}
const api = new AAMiddleware()

export default function GlobalModals() {
    const modals = useModals()
    const ual = useContext(UALContext) as any;

    const [backerAccounts,setBackerAccounts] = useState<Array<string>>()
    const [balances,setBalances] = useState<Array<IBackedAmount>>([])

    useEffect(()=> {
        const loadBackerAccounts = async () => {
            const collections = await api.getBackedCollectionsFromContract()
            const newBackerAccounts = collections.map((c) => c.owner)
            setBackerAccounts(newBackerAccounts)
        }
        loadBackerAccounts();
    },[])   

    useEffect(() => {
        if ( ! ual || ! ual.activeUser || ! ual.activeUser.accountName ) { return }
        const loadBalances = async () => {
            const textBalances = await api.getBalances(ual.activeUser.accountName) as any
            const newBalances = textBalances.map((b)=>{
                const parts = b.split(' ')
                return {
                    amount: parts[0],
                    token_symbol: parts[1],
                } as IBackedAmount
            })
            setBalances(newBalances)
        }
        loadBalances()
    }, [ual.activeUser])


    useEffect(()=>{
        if ( ! ual || ! ual.activeUser || ! ual.activeUser.userAccount || ! backerAccounts?.includes(ual.activeUser.userAccount) ) { return }
        if ( balances.length == 0 ) { return }

        modals.openModal({
            title: <><Space h={30} /></>,
            children: <UnclaimedBalanceNotification balances={balances} />,
            size: '90%',
            padding: 0,
            withCloseButton: false,
            radius: 'lg'
          } as ModalProps)

    },[backerAccounts,balances])

    return (
        <>
        </>
    )
}